import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuFolderRoot, LuHistory, LuInfo} from 'react-icons/lu'

export function UserDrawerTabsList() {
  const {t} = useTranslate('common')

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>

      <Tabs.Trigger value="group_permissions" data-e2e="group-permissions-trigger">
        <LuFolderRoot />
        {t('group_&_permissions')}
      </Tabs.Trigger>

      <Tabs.Trigger value="activity" data-e2e="history-trigger">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
